import { RRITag } from '../../../tags/interfaces/tag.interface';

export interface RRITableFieldSettings<T> {
  fieldName: keyof T;
  title: string;
  hide?: boolean;
  headerClass?: string;
  fieldClass?:
    | ((fieldName: RRITableFieldSettings<T>, row: T) => string)
    | string;
  sortable?: boolean;
  tooltip?: ((fieldName: RRITableFieldSettings<T>, row: T) => string) | string;
  format?: (fieldName: RRITableFieldSettings<T>, row: T) => string;
  tagClicked?: (tag: RRITag) => void;
}
